import React, { useMemo } from "react";
import { useMeeting } from "@videosdk.live/react-sdk";
import { MemoizedParticipantGrid } from "../../../features/meeting/ParticipantGrid";

function ParticipantsViewer({
  isPresenting,
  isBotSpeaking,
  activePanelSpeaker,
}) {
  const {
    participants,
    pinnedParticipants,
    activeSpeakerId,
    localParticipant,
    localScreenShareOn,
    presenterId,
  } = useMeeting();

  const participantIds = useMemo(() => {
    // During meeting teardown (e.g. reconnect -> submit -> assessment
    // complete/success), useMeeting() briefly returns localParticipant as
    // null / participants and pinnedParticipants as empty before this
    // component unmounts. Bail out to an empty list on that in-between
    // render instead of dereferencing .id on null.
    if (!localParticipant || !participants || !pinnedParticipants) {
      return [];
    }

    const localParticipantId = localParticipant.id;

    const pinnedParticipantId = [...pinnedParticipants.keys()].filter(
      (participantId) => {
        return participantId !== localParticipantId;
      },
    );
    const regularParticipantIds = [...participants.keys()].filter(
      (participantId) => {
        return (
          ![...pinnedParticipants.keys()].includes(participantId) &&
          localParticipantId !== participantId
        );
      },
    );

    const ids = [
      localParticipantId,
      ...pinnedParticipantId,
      ...regularParticipantIds,
    ].slice(0, isPresenting ? 6 : 16);

    if (activeSpeakerId) {
      if (!ids.includes(activeSpeakerId)) {
        ids[ids.length - 1] = activeSpeakerId;
      }
    }
    return ids;
  }, [
    participants,
    activeSpeakerId,
    pinnedParticipants,
    presenterId,
    localScreenShareOn,
    localParticipant,
  ]);

  return (
    <MemoizedParticipantGrid
      participantIds={participantIds}
      isPresenting={isPresenting}
      includeBotParticipant={true}
      isBotSpeaking={isBotSpeaking}
      activePanelSpeaker={activePanelSpeaker}
    />
  );
}

const MemorizedParticipantView = React.memo(
  ParticipantsViewer,
  (prevProps, nextProps) => {
    return (
      prevProps.isPresenting === nextProps.isPresenting &&
      prevProps.isBotSpeaking === nextProps.isBotSpeaking &&
      prevProps.activePanelSpeaker === nextProps.activePanelSpeaker
    );
  },
);
export default MemorizedParticipantView;
